/**
 * ログイン画面用のJS
 */
(function () {
    this.SignIn = (function () {
        function SignIn() {
            this.setListener();

            if (window != parent) {
                top.location.href = "/login";
            }
        }

        SignIn.prototype.setListener = function () {
            // パスワード表示/非表示の切り替え
            const passwordInput = document.querySelector('input[name="password"]');
            const eyeIcon = document.querySelector('.ion-eye');
            const eyeDisabledIcon = document.querySelector('.ion-eye-disabled');

            eyeIcon.addEventListener('click', () => {
                passwordInput.type = 'text';
                eyeIcon.style.display = 'none';
                eyeDisabledIcon.style.display = 'block';
            });

            eyeDisabledIcon.addEventListener('click', () => {
                passwordInput.type = 'password';
                eyeIcon.style.display = 'block';
                eyeDisabledIcon.style.display = 'none';
            });
        };

        return SignIn;
    })();
}).call(this);
